import React from "react";
import {
  List,
  DataTable,
  TextField,
  useRecordContext,
  Pagination,
  SimpleForm,
  TextInput,
  Create,
  Edit,
  useInput,
  EditButton,
  TopToolbar,
  ColumnsButton,
  CreateButton,
} from "react-admin";
import { FermentAutomation } from "../lib/fermentAutomation";
import { FermentAutomationStepsMiniField } from "../lib/fermentAutomation/mini";
import { hasScope, SCOPE } from "../lib/auth";

export const AutomationProtocolList = (props: any) => (
  <List
    {...props}
    perPage={100}
    pagination={<Pagination rowsPerPageOptions={[100, 200, 500, 1000]} />}
    actions={
      <TopToolbar>
        <CreateButton disabled={!hasScope(SCOPE.MANAGER)} />
        <ColumnsButton />
      </TopToolbar>
    }
    sort={{ field: "id", order: "ASC" }}
    storeKey={false}
    empty={false}
  >
    <DataTable rowClick={false} bulkActionButtons={false}>
      <DataTable.Col source="id" disableSort>
        <TextField source="id" />
      </DataTable.Col>
      <DataTable.Col source="name" disableSort>
        <TextField source="name" />
      </DataTable.Col>
      <DataTable.Col source="phases" disableSort>
        <FermentAutomationStepsMiniField />
      </DataTable.Col>
      {hasScope(SCOPE.MANAGER) && (
        <DataTable.Col>
          <EditButton />
        </DataTable.Col>
      )}
    </DataTable>
  </List>
);

const AutomationProtocolInput = () => {
  const { field } = useInput({
    source: "automation.steps",
  });

  return (
    <FermentAutomation
      value={field.value || []}
      onChange={field.onChange}
      style={{ width: "100%" }}
    />
  );
};

export const AutomationProtocolCreate = () => (
  <Create redirect="list">
    <SimpleForm>
      <TextInput
        source="name"
        label="Name"
        validate={(v: string) => !v && "Name is required"}
      />
      <AutomationProtocolInput />
    </SimpleForm>
  </Create>
);

export const AutomationProtocolEdit = () => (
  <Edit title={<AutomationProtocolAppBarTitle />}>
    <SimpleForm>
      <TextInput source="name" label="Protocol Name" />
      <AutomationProtocolInput />
    </SimpleForm>
  </Edit>
);

const AutomationProtocolAppBarTitle = () => {
  const record = useRecordContext();
  if (!record) return null;
  return <span>{record.name} Protocol</span>;
};
